import { Injectable } from '@angular/core';
import { StorageService } from '../../services/storage-service/storage.service';
import { RBS_TOKEN } from '../store/multi-stage-assignment-report.model';

@Injectable({
    providedIn: 'root',
})
export class MultiStageAuthService {
    constructor(private readonly storageService: StorageService) {}

    getRbsToken(): string {
        const token = this.storageService.getItem(RBS_TOKEN);
        const realizeRBSToken = this.storageService.getRealizeRbsToken();
        return (realizeRBSToken && realizeRBSToken.id) ? (realizeRBSToken.id).replace(/['"]+/g, '') : token;
    }

    isRBSTokenValid(): boolean {
        const realizeRBSToken = this.storageService.getRealizeRbsToken();
        const expireDate = realizeRBSToken && realizeRBSToken.expireDate ? realizeRBSToken.expireDate : null;
        return expireDate ? expireDate > Date.now() : false;
    }
}
